import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Fingerprint, Menu, Phone } from "lucide-react";
import { COMPANY } from "../../data/content";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Details", href: "#service-details" },
  { label: "Book Now", href: "#booking" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b shadow-sm">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center shrink-0" data-testid="header-logo">
          <img src="/logo.png" alt="Cayman Fingerprinting Services Ltd." className="h-12 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-6">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="text-sm font-medium text-foreground/80 hover:text-[color:var(--brand-navy)] transition-colors duration-200"
              data-testid={`header-nav-${link.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            className="hidden sm:inline-flex border-[color:var(--brand-navy)] text-[color:var(--brand-navy)] hover:bg-secondary btn-lift"
            asChild
            data-testid="header-call-now-button"
          >
            <a href={COMPANY.phoneHref}>
              <Phone className="h-4 w-4 mr-1.5" /> Call Now
            </a>
          </Button>
          <Button
            size="sm"
            className="bg-[color:var(--brand-navy)] hover:bg-[color:var(--brand-navy-2)] btn-lift"
            onClick={() => scrollTo("#booking")}
            data-testid="header-schedule-appointment-button"
          >
            Schedule Appointment
          </Button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="lg:hidden" data-testid="header-mobile-menu-button">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72">
              <div className="flex flex-col gap-1 mt-8">
                {NAV_LINKS.map((link) => (
                  <button
                    key={link.href}
                    onClick={() => scrollTo(link.href)}
                    className="text-left px-3 py-3 rounded-lg text-base font-medium hover:bg-secondary transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                ))}
                <a
                  href={COMPANY.phoneHref}
                  className="px-3 py-3 rounded-lg text-base font-medium text-[color:var(--brand-navy)] hover:bg-secondary inline-flex items-center gap-2 transition-colors duration-200"
                >
                  <Phone className="h-4 w-4" /> {COMPANY.phone}
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
